import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ff19017"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col justify-between" }
const _hoisted_2 = { class: "flex-grow flex flex-col justify-end message-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessengerMessage = _resolveComponent("MessengerMessage")!
  const _component_MessengerPoweredByFooter = _resolveComponent("MessengerPoweredByFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
        return (_openBlock(), _createElementBlock("div", {
          key: message.messageId,
          class: "flex flex-col w-full px-4 message"
        }, [
          _createVNode(_component_MessengerMessage, { message: message }, null, 8, ["message"])
        ]))
      }), 128))
    ]),
    _createVNode(_component_MessengerPoweredByFooter, { class: "flex justify-center w-full items-center content-center align-center" })
  ]))
}